import { computed, Injectable, signal } from '@angular/core';

/** Compte les requetes d'ecriture (POST, PUT, PATCH, DELETE) en cours ; alimente par l'intercepteur global. */
@Injectable({ providedIn: 'root' })
export class EcrituresEnCoursService {
  private readonly enVol = signal(0);

  /** Vrai tant qu'au moins une ecriture n'a pas recu sa reponse. */
  readonly enCours = computed(() => this.enVol() > 0);

  debut(): void {
    this.enVol.update(n => n + 1);
  }

  fin(): void {
    this.enVol.update(n => Math.max(0, n - 1));
  }
}
